import React from "react";
import { useI18n } from "@/i18n";

const IMAGES = [
  { src: "https://images.unsplash.com/photo-1724500123062-ca4c00df91e6?w=1400&q=85", region: "Loire" },
  { src: "https://images.unsplash.com/photo-1543418219-44e30b057fea?w=1400&q=85", region: "Champagne" },
  { src: "https://images.unsplash.com/photo-1689275232185-957a6dbae87b?w=1400&q=85", region: "Provence" },
  { src: "https://images.unsplash.com/photo-1492136344046-866c85e0bf04?w=1400&q=85", region: "Paris" },
  { src: "https://images.unsplash.com/photo-1756674105285-a136b84d869c?w=1400&q=85", region: "Riviera" },
  { src: "https://images.unsplash.com/photo-1773859095615-141a2564298b?w=1400&q=85", region: "Bourgogne" },
];

export default function Gallery() {
  const { lang } = useI18n();
  return (
    <div className="max-w-[1400px] mx-auto px-6 md:px-12 pt-16 pb-32">
      <div className="overline text-[#D4AF37]">{lang === "fr" ? "Galerie" : "Gallery"}</div>
      <h1 className="font-serif font-light text-5xl md:text-7xl text-[#0A1128] mt-4">
        {lang === "fr" ? "Un carnet visuel." : "A visual notebook."}
      </h1>
      <div className="mt-16 grid grid-cols-1 md:grid-cols-6 gap-4 md:gap-6" data-testid="gallery-grid">
        {IMAGES.map((im, i) => {
          // Bento layout: alternating column spans
          const spans = ["md:col-span-4", "md:col-span-2", "md:col-span-2", "md:col-span-4", "md:col-span-3", "md:col-span-3"];
          const heights = ["h-[520px]", "h-[380px]", "h-[380px]", "h-[520px]", "h-[440px]", "h-[440px]"];
          return (
            <figure key={i} className={`${spans[i]} hover-scale overflow-hidden`} data-testid={`gallery-item-${i}`}>
              <img src={im.src} alt={im.region} className={`w-full ${heights[i]} object-cover`} />
              <figcaption className="mt-3 text-xs tracking-[0.24em] uppercase text-[#0A1128]/60">{im.region}</figcaption>
            </figure>
          );
        })}
      </div>
    </div>
  );
}
